// @flow

import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import logo from "../../../images/logo_button.png"

export default ({ showLogo = true }: { showLogo?: boolean }) => {
    const data = useStaticQuery(graphql`
        query BioQuery {
            site {
                siteMetadata {
                    author {
                        name
                        summary
                    }
                }
            }
        }
    `)

    const author = data.site.siteMetadata.author

    return (
        <>
            {showLogo && (
                <p className="valign-wrapper" style={{ marginBottom: 10 }}>
                    <img
                        src={logo}
                        width={35}
                        alt="SimplyRETS logo"
                        style={{ marginRight: 10 }}
                    />
                    <strong>{author.name}</strong>
                </p>
            )}
            <p style={{ marginBottom: 5, lineHeight: 1 }}>
                <i>{author.summary}</i>.
            </p>
            <p style={{ marginTop: 0, lineHeight: 1 }}>
                <small>
                    Learn more at{" "}
                    <a href="https://simplyrets.com">simplyrets.com</a>, get
                    started with the{" "}
                    <a href="https://docs.simplyrets.com">API docs</a>.
                </small>
            </p>
        </>
    )
}
